import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PurchaseServices from '../services/PurchaseServices';
import useAsync from '../hooks/useAsync';
import TogelButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import UpdatePurchase from './Update Model/UpdatePurchase';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function PurchaseList() {
  const { data, error, isLoading, run } = useAsync(PurchaseServices.getPurchase);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleEditDetails = (coupan) => {
    setSelectedEdit(coupan);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (coupan) => {
    setSelectedEdit(coupan);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };



  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  const filteredData = data?.data?.filter(purchase => {
    const name = purchase.name ? purchase.name.toLowerCase() : "";
    const amount = purchase.amount ? purchase.amount.toString().toLowerCase() : "";


    const purchaseDate = new Date(purchase.date);
    const purchaseDateOnly = new Date(purchaseDate.setHours(0, 0, 0, 0));


    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    const isInDateRange = purchaseDateOnly >= start && purchaseDateOnly <= end;
    return (name.includes(searchQuery.toLowerCase()) || amount.includes(searchQuery.toLowerCase())) && isInDateRange;
  });


  // const generateExcel = () => {
  //   const filteredData = data?.data?.map(purchase => ({
  //     Name: purchase?.itemName,
  //     amount: purchase?.amount,
  //     vendorName: purchase?.vendorDetails?.name,
  //     vendorContact: purchase?.vendorDetails?.contact,
  //     date: formatDateTime(purchase?.date),

  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'PurchaseDate');
  //   XLSX.writeFile(wb, 'purchase_data.xlsx');
  // };


  const generateExcel = () => {
    const filteredDataForExcel = filteredData?.map(purchase => ({
      Name: purchase?.itemName,
      amount: purchase?.amount,
      vendorName: purchase?.vendorDetails?.name,
      vendorContact: purchase?.vendorDetails?.contact,
      date: formatDateTime(purchase?.date),
    }));

    const ws = XLSX.utils.json_to_sheet(filteredDataForExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'PurchaseData');
    XLSX.writeFile(wb, 'purchase_data.xlsx');
  };


  //   function truncateText(text = '', limit) {
  //     const words = text.split(' ');
  //     if (words.length > limit) {
  //       return words.slice(0, limit).join(' ') + '...';
  //     }
  //     return text;
  //   }
  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Purchase Item List <span className="badge bg-orange">{filteredData?.length || 0}</span>                            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Order
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="round-add-btn" to="/add-purchase">
              <img src="img/plus.svg" alt="Add Coupan" />
            </Link>
            <div className="pe-1 mb-xl-0">


            </div>



          </div>
        </div>

        <div className='d-flex justify-content-between align-items-center'>
          <div className="date-picker-container d-flex gap-3 align-items-center">
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              dateFormat="dd/MM/yyyy"
              isClearable
              placeholderText="Start Date"
              className='form-control'
            />
            <FaArrowRightArrowLeft />
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              dateFormat="dd/MM/yyyy"
              isClearable
              placeholderText="End Date"
              className='form-control'
            />
          </div>
          <button className="excel-btn" onClick={generateExcel}>
            <img src="img/excel.svg" alt="Download Excel" />
            Download
          </button>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search "
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className='form-control'
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>ITEM NAME</th>
                  <th>AMOUNT</th>
                  <th>SLIP</th>
                  <th>Bill Number</th>
                  <th>VENDOR NAME</th>
                  <th>VENDOR CONTACT</th>
                  <th>DATE</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((coupan, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>

                    <td>{coupan?.itemName}</td>
                    <td>{coupan?.amount}</td>
                    <td>
                      <div className="product-img">
                        {coupan?.image ? (
                          <img
                            src={process.env.REACT_APP_URL + coupan.image}
                            alt="Product"
                            style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                          />
                        ) : (
                          <span>N/A</span>
                        )}
                      </div>
                    </td>
                    <td>{coupan?.billNumber}</td>
                    <td>{coupan?.vendorDetails?.name}</td>
                    <td>{coupan?.vendorDetails?.contact}</td>
                    <td>{formatDateTime(coupan?.date)}</td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(coupan)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(coupan)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <UpdatePurchase data={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Purchase" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
      </div>
    </>
  );
}

export default PurchaseList;
